import { RENT_CHARGER_ID, BUY_CHARGER_ID } from '../constants/';

const chargerPaymentOptions = [
  {id: RENT_CHARGER_ID, value: 'Rent', title: 'Rent'},
  {id: BUY_CHARGER_ID, value: 'Buy', title: 'Buy'}
];

export default chargerPaymentOptions;
